@if (updateAvailable()) {
  <div class="bg-primary text-light text-center py-1 w-100" style="position: sticky; top: 0; z-index: 1050">
    <span
      ><i class="bi bi-arrow-repeat"></i> Er is een update beschikbaar!
      <button (click)="updateApp()" class="btn btn-sm btn-outline-light ms-2" style="--bs-btn-padding-y: 0.05rem">
        Vernieuwen
      </button>
    </span>
  </div>
}
